import { useState } from "react";
import styles from "./IssuesView.module.scss";
import { Pagination, View, ViewHeader } from "@/components";
import { IssueExportModal, IssuesList, IssuesToolbar } from "..";
import { useIssuesQuery } from "../../_hooks/useIssuesQuery";
import { useIssuesStore } from "../../_store/useIssues.store";

export const IssuesView = () => {
  const type = useIssuesStore((state) => state.type);
  const period = useIssuesStore((state) => state.period);
  const status = useIssuesStore((state) => state.status);
  const page = useIssuesStore((state) => state.page);
  const limit = useIssuesStore((state) => state.limit);
  const setType = useIssuesStore((state) => state.setType);
  const setPeriod = useIssuesStore((state) => state.setPeriod);
  const setStatus = useIssuesStore((state) => state.setStatus);
  const setPage = useIssuesStore((state) => state.setPage);
  const setLimit = useIssuesStore((state) => state.setLimit);
  const { data, isLoading, isFetching, isError, refetch } = useIssuesQuery();
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const issues = data?.items ?? [];
  const meta = data?.meta ?? {
    total: 0,
    page,
    limit,
    totalPages: 1,
  };

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Issues"
          description="Review reported problems, follow their status, and keep track of open items.<br />Use this space to manage product and support issues."
        />

        <IssuesToolbar
          type={type}
          period={period}
          status={status}
          onTypeChange={setType}
          onPeriodChange={setPeriod}
          onStatusChange={setStatus}
          onExportClick={() => setIsExportModalOpen(true)}
        />

        <IssuesList
          issues={issues}
          isLoading={isLoading}
          isFetching={isFetching}
          isError={isError}
          onRetry={() => refetch()}
        />

        {meta.total > 0 && (
          <Pagination
            page={meta.page}
            limit={meta.limit}
            total={meta.total}
            totalPages={meta.totalPages}
            onPageChange={setPage}
            onRowsPerPageChange={setLimit}
          />
        )}

        <IssueExportModal
          isOpen={isExportModalOpen}
          type={type}
          period={period}
          status={status}
          onClose={() => setIsExportModalOpen(false)}
        />
      </div>
    </View>
  );
};
